import { Directive, OnDestroy } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[ignoreDirty]',
})
export class IgnoreDirtyDirective implements OnDestroy {
  private subscription: Subscription | undefined;

  constructor(private control: NgControl) {
    setTimeout(() => {
      this.subscription = this.control.valueChanges?.subscribe((v) => {
        if (this.control.dirty) {
          this.control.control?.markAsPristine();
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
